import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface IPrivateRoute {
  requiredRoles?: string[];
  children?: React.ReactNode;
}

export default function PrivateRoute({
  requiredRoles = [],
  children,
}: IPrivateRoute) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
  const userRoles: string[] = currentUser?.roles || [];

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  const hasPermission =
    requiredRoles.length === 0 ||
    requiredRoles.some(role => userRoles.includes(role));

  if (!hasPermission) {
    return <Navigate to="/painel" state={{ from: location }} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
}
